import { Box, Col, Divider, Icon, Row } from '@betterleap/ui';

const details: string[] = [
  'Promoted jobs are shown at the top of the search results',
  'Top placement in job recommendations',
  'Mobile alerts for qualified candidates',
];

export const JobPromotionDetails = () => {
  return (
    <Box
      css={{
        margin: 20,
        position: 'relative',
        border: '1px solid $neutral-blue-200',
        boxShadow: '$md',
        borderRadius: '$3xl',
        pt: 24,
        pl: 24,
        pb: 24,
        flex: 1,
        backgroundColor: 'white',
      }}
    >
      {details.map((detail: string, index: number) => {
        return (
          <>
            <Row css={{ display: 'flex', alignItems: 'start' }}>
              <Icon name={'check-circle'} color={'$green-600'} />
              <Box css={{ display: 'inline' }}>
                <Col css={{ fontSize: '$sm' }}>{detail}</Col>
              </Box>
            </Row>
            {index != details.length - 1 ? (
              <Col>
                <Divider
                  className='mt-3 mb-3'
                  style={{ marginLeft: '2.5em', width: 'auto' }}
                  css={{
                    color: '$neutral-blue-200',
                  }}
                />
              </Col>
            ) : null}
          </>
        );
      })}
    </Box>
  );
};
